import { editLightLogo, editDarkLogo, editCompanySeal } from "../../api/companyInfo/logos.js";
import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import { UploadImage } from "../../../../shared/ui/common/index.js";



import { setCompanyInfo } from "../../../../shared/state/slices/relationals.js";

const Logos = ({ data }) => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const { companyInfo } = useSelector((state) => state.relationals);
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [avatar, setAvatar] = useState(null);
  const [selectedProductImage, setselectedProductImage] = useState(null);
  const [avatarD, setAvatarD] = useState(null);
  const [selectedProductImageD, setselectedProductImageD] = useState(null);
  const [avatarS, setAvatarS] = useState(null);
  const [selectedProductImageS, setselectedProductImageS] = useState(null);
  const [loading, setLoading] = useState({
    dark: false,
    light: false,
    sale: false,
  });
  const handleLogoes = () => {
    if (
      avatar ||
      (selectedProductImage && selectedProductImage !== data?.companyGalleryId)
    ) {
      setLoading({ ...loading, light: true });
      const formData1 = new FormData();
      if (avatar) {
        formData1.append("files", avatar);
      } else {
        formData1.append("fromGallery", selectedProductImage);
      }
      editLightLogo(formData1, token)
        .then((res) => {
          toast.success("با موفقیت لوگو روشن ویرایش شد");
          dispatch(
            setCompanyInfo({
              ...companyInfo,
              companyLogo: res.data.data.companyGalleryId,
            })
          );

          setLoading({ ...loading, light: false });
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
          setLoading({ ...loading, light: false });
        });
    }
    if (
      avatarD ||
      (selectedProductImageD && selectedProductImageD !== data?.companyDarkLogo)
    ) {
      const formData1 = new FormData();
    
      if (avatarD) {
        formData1.append("files", avatarD);
      } else {
        formData1.append("fromGallery", selectedProductImageD);
      }
      setLoading({ ...loading, dark: true });
      editDarkLogo(formData1, token)
        .then((res) => {
          toast.success("با موفقیت لوگو تیره ویرایش شد");
          dispatch(
            setCompanyInfo({
              ...companyInfo,
              companyDarkLogo: res.data.data.companyDarkLogo,
            })
          );
          setLoading({ ...loading, dark: false });
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
          setLoading({ ...loading, dark: false });
        });
    }
    if (
      avatarS ||
      (selectedProductImageS && selectedProductImageS !== data?.companySeal)
    ) {
      const formData1 = new FormData();
      if (avatarS) {
        formData1.append("files", avatarS);
      } else {
        formData1.append("fromGallery", selectedProductImageS);
      }
      setLoading({ ...loading, sale: true });
      editCompanySeal(formData1, token)
        .then((res) => {
          toast.success("با موفقیت مهر شرکت ویرایش شد");
          dispatch(
            setCompanyInfo({
              ...companyInfo,
              companySeal: res.data.data.companySeal,
            })
          );
          setLoading({ ...loading, sale: false });
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
          setLoading({ ...loading, sale: false });
        });
    }
  };
  return (
    <div className="md:grid md:grid-cols-4 gap-5 flex flex-col">
      <div>
        <div className="my-3"> - لوگو روشن</div>
        <div className="flex md:gap-10 gap-4 flex-wrap items-end">

            <UploadImage
              file={avatar}
              change={setAvatar}
              address={data?.companyGalleryId}
              selectedProductImage={selectedProductImage}
              setselectedProductImage={setselectedProductImage}
            />
        
        </div>
      </div>
      <div>
        <div className="my-3"> - لوگو تیره</div>
        <div className="flex md:gap-10 gap-4 flex-wrap items-end">
      
            <UploadImage
              file={avatarD}
              change={setAvatarD}
              address={data?.companyDarkLogo}
              selectedProductImage={selectedProductImageD}
              setselectedProductImage={setselectedProductImageD}
            />
     
        </div>
      </div>
      <div>
        <div className="my-3"> - مهر شرکت</div>
        <div className="flex md:gap-10 gap-4 flex-wrap items-end">

            <UploadImage
              file={avatarS}
              change={setAvatarS}
              address={data?.companySeal}
              selectedProductImage={selectedProductImageS}
              setselectedProductImage={setselectedProductImageS}
            />
   
        </div>{" "}
      </div>{" "}
      <div className="flex justify-end items-end">
        {" "}
        <Button
          disabled={loading.dark || loading.light || loading.sale}
          onClick={handleLogoes}
          variant="contained"
        >
          {loading.dark || loading.light || loading.sale ? (
            <CircularProgress />
          ) : (
            <>ثبت اطلاعات</>
          )}
        </Button>
      </div>
    </div>
  );
};

export default Logos;
